<div class="basin-display-flex basin-justify-content-space-between basin-align-items-center">
  <div class="basin-font-size-14 basin-color-true-white">
    {{label}}
  </div>
  <span class="basin-font-size-14 basin-color-true-white">
    {{value}}
  </span>
</div>
